import { render } from "./PdfViewer.vue?vue&type=template&id=2d18469e&scoped=true"
import script from "./PdfViewer.vue?vue&type=script&lang=js"
export * from "./PdfViewer.vue?vue&type=script&lang=js"

import "./PdfViewer.vue?vue&type=style&index=0&id=2d18469e&lang=scss"
import "./PdfViewer.vue?vue&type=style&index=1&id=2d18469e&lang=scss&scoped=true"

import exportComponent from "/pxplus_official_website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d18469e"]])

export default __exports__